export default __webpack_public_path__ + "static/media/india2018A.1cebffcc.jpg";